module.exports = __webpack_public_path__ + "assets/img/xitong.df350290.png";